import { RegularShape } from 'ol/style';
import { asColorLike } from 'ol/colorlike';
export default class CrossStyle extends RegularShape {
    constructor(options) {
        super(options);
    }

    draw_(renderOptions, context, pixelRatio) {
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        context.translate(0, 0);
        context.beginPath();

        let symbolSize = renderOptions.size - 1 - (2 * renderOptions.strokeWidth);
        var smallSide = symbolSize - parseInt((symbolSize / 5) * 2) * 2;
        var bigSide = parseInt((symbolSize / 5) * 2);

        context.moveTo(bigSide, 0);
        context.lineTo(bigSide + smallSide, 0);
        context.lineTo(bigSide + smallSide, bigSide);
        context.lineTo(symbolSize, bigSide);
        context.lineTo(symbolSize, bigSide + smallSide);
        context.lineTo(bigSide + smallSide, bigSide + smallSide);
        context.lineTo(bigSide + smallSide, symbolSize);
        context.lineTo(bigSide, symbolSize);
        context.lineTo(bigSide, bigSide + smallSide);
        context.lineTo(0, bigSide + smallSide);
        context.lineTo(0, bigSide);
        context.lineTo(bigSide, bigSide);
        context.lineTo(bigSide, 0);

        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) {
                color = defaultFillStyle;
            }
            context.fillStyle = asColorLike(color);
            context.fill();
        }
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (context.setLineDash && renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
        context.closePath();
    }
}